import { render, staticRenderFns } from "./RegisterItem.vue?vue&type=template&id=2ebad4dd"
import script from "./RegisterItem.vue?vue&type=script&lang=js"
export * from "./RegisterItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports